export default __webpack_public_path__ + "static/media/react-2.b23d3342.webp";